export enum SpinOpacity {
    Visible = 'visible',
    SlightlyTransparent = 'slightly-transparent',
    ModeratelyTransparent = 'moderately-transparent',
    HighlyTransparent = 'highly-transparent',
    Invisible = 'invisible'
}